module.exports = __webpack_public_path__ + "img/tips-packing.24014bc2.svg";